import { StoreState } from '@/redux/types';

export const selectFilter = (state: StoreState) => state.productTypes.filter;
